var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"html-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.config},model:{value:(_vm.html),callback:function ($$v) {_vm.html=$$v},expression:"html"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }